<div *ngIf="isVisible" class="small callout {{ data.type }}">
  <i *ngIf="data.type" class="fa {{ data.type | messageTypeIcon }}"></i>
  {{ data.message }}
  <button (click)="message.hide(id)" class="small close-button" aria-label="Dismiss alert" type="button" data-close>
    <span aria-hidden="true">&times;</span>
  </button>
</div>
